module.exports = __webpack_public_path__ + "assets/img/Edito_Mouhammed-Choukeir_menu.6ddaf789-ps.jpg";